import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  Button,
  Checkbox,
  Dropdown,
  Form,
  Icon,
  Input,
  Popup,
  Header,
  Modal
} from "semantic-ui-react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Field, Formik, useFormikContext } from "formik";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";

import styles from "./NewInterval.module.css";
import { BULK_CREATE_INTERVALS_INITIAL_VALUES } from "constants/WorkingTime";
import {
  generalTasksOptions,
  generalTasksAssignTo
} from "selectors/generalTasks";
import DropdownTree from "./DropdownTree/AreaDropDown";
import { fetchGeneralTaskList } from "actions/Tasks";

import { EmployeesDropdown } from "./EmployeesDropdown/EmployeesDropdown";

const NewIntervalForm = ({
  intervalData,
  intervalsListCheck,
  selectedItem,
  generalTaskList,
  checkHandler,
  index
}) => {
  const dispatch = useDispatch();
  const { values, setFieldValue } = useFormikContext();

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const generalTaskIdList = useSelector(generalTasksOptions) || [];
  const employees = useSelector(generalTasksAssignTo).options.map(item => ({
    key: item.key,
    text: item.label,
    value: item.value
  }));

  useEffect(() => {
    !generalTaskList.length && dispatch(fetchGeneralTaskList());
  }, []);

  const onDeleteClick = index => {
    const intervals = values.intervals?.filter((_, i) => i !== index);

    setFieldValue("intervals", intervals);
    setShowDeleteModal(false);
  };

  return (
    <>
      <Modal
        className={styles.deleteModal}
        size="mini"
        open={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
      >
        <Modal.Content>Delete interval?</Modal.Content>
        <Modal.Actions>
          <Button
            className={styles.cancelDltBtn}
            onClick={() => setShowDeleteModal(false)}
          >
            Cancel
          </Button>
          <Button
            className={styles.deleteBtn}
            positive
            onClick={() => onDeleteClick(index)}
          >
            Delete
          </Button>
        </Modal.Actions>
      </Modal>

      <Formik
        enableReinitialize
        validateOnBlur
        initialValues={BULK_CREATE_INTERVALS_INITIAL_VALUES || intervalData}
      >
        <Form>
          <Form.Group className={styles.rowWrapper}>
            <Form.Field className={styles.costtypeLabel} width={2}>
              <div className={styles.checkboxWrapper}>
                <Checkbox
                  checked={selectedItem?.includes(index)}
                  onChange={() => checkHandler(index)}
                />
              </div>

              <Dropdown
                placeholder="Select"
                name="generalTaskId"
                scrolling
                className={styles.gtId}
                clearable
                openOnFocus
                search
                options={generalTaskIdList.options}
                value={intervalData.generalTaskId}
                onChange={(e, { value }) => {
                  setFieldValue(`intervals[${index}].generalTaskId`, value);
                }}
              />
            </Form.Field>

            <Form.Field width={2}>
              <div className={styles.dropdownTreeWrapper}>
                <div className={styles.dropdownTreeContainer}>
                  <DropdownTree
                    data={intervalData.areaData}
                    intervalIndex={index}
                    handleAreaSelectTreeChange={setFieldValue}
                  />
                </div>
              </div>
            </Form.Field>

            <Form.Field width={2}>
              <EmployeesDropdown
                text={
                  !!intervalData.employee.length &&
                  `${intervalData.employee.length} employee${
                    intervalData.employee.length > 1 ? "s" : ""
                  }`
                }
                value={intervalData.employee}
                list={employees}
                selectedValues={intervalData.employee}
                onChange={value => {
                  const employee = intervalData.employee.includes(value)
                    ? intervalData.employee.filter(id => id !== value)
                    : [...intervalData.employee, value];

                  setFieldValue(`intervals[${index}].employee`, employee);
                }}
              />
            </Form.Field>

            <Form.Field width={3}>
              <DatePicker
                className={styles.dateTimeCalendar}
                format="DD/MM/YYYY HH:mm"
                placeholder="dd/mm/yyyy hh:mm:ss"
                buttons={false}
                plugins={[
                  <TimePicker
                    style={{ maxWidth: "250px" }}
                    disableClock={true}
                    hideSeconds
                    position="bottom"
                  />
                ]}
                render={
                  <Input
                    placeholder={"dd/mm/yyyy"}
                    icon={<Icon name="calendar outline" />}
                    iconPosition="right"
                  />
                }
                value={
                  intervalData.startAt
                    ? `${moment(intervalData.startAt).format(
                        "DD/MM/YYYY HH:mm:ss"
                      )}`
                    : null
                }
                onChange={value => {
                  const startAt =
                    value === null
                      ? value
                      : moment(new Date(value?.toDate?.().toString())).format(
                          "YYYY-MM-DDTHH:mm:ss"
                        );

                  setFieldValue(`intervals[${index}].startAt`, startAt);
                }}
              />
            </Form.Field>

            <Form.Field width={3}>
              <DatePicker
                className={styles.dateTimeCalendar}
                format="DD/MM/YYYY HH:mm"
                placeholder="dd/mm/yyyy hh:mm:ss"
                buttons={false}
                plugins={[
                  <TimePicker
                    style={{ maxWidth: "250px" }}
                    disableClock={true}
                    hideSeconds
                    position="bottom"
                  />
                ]}
                render={
                  <Input
                    placeholder={"dd/mm/yyyy"}
                    icon={<Icon name="calendar outline" />}
                    iconPosition="right"
                  />
                }
                value={
                  intervalData.endAt
                    ? `${moment(intervalData.endAt).format(
                        "DD/MM/YYYY HH:mm:ss"
                      )}`
                    : null
                }
                onChange={value => {
                  const endAt =
                    value === null
                      ? value
                      : moment(new Date(value?.toDate?.().toString())).format(
                          "YYYY-MM-DDTHH:mm:ss"
                        );

                  setFieldValue(`intervals[${index}].endAt`, endAt);
                }}
              />
            </Form.Field>

            <Form.Field width={2}>
              <Field
                placeholder={0}
                as={Input}
                className={styles.disabledField}
                value={intervalData.lunchInterval}
                name="lunchInterval"
                onKeyPress={event => {
                  if (!/^[0-9.]+$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onChange={(e, { value }) => {
                  setFieldValue(`intervals[${index}].lunchInterval`, value);
                }}
              />
            </Form.Field>

            <Form.Field className={styles.buttonContainer} width={2}>
              <Popup
                inverted
                content={"Delete"}
                size="tiny"
                position="center bottom"
                trigger={
                  <span className={styles.deleteIconWrapper}>
                    <Button
                      type="reset"
                      disabled={intervalsListCheck < 2}
                      onClick={() => setShowDeleteModal(true)}
                      className={styles.deleteButton}
                      icon={
                        <Icon
                          className={styles.deleteIcon}
                          name="trash alternate"
                        />
                      }
                    />
                  </span>
                }
              />
              <Popup
                inverted
                content={"Copy"}
                size="tiny"
                position="center bottom"
                trigger={
                  <span className={styles.copyIconWrapper}>
                    <Button
                      type="reset"
                      onClick={() =>
                        setFieldValue("intervals", [
                          ...values.intervals,
                          values.intervals[index]
                        ])
                      }
                      className={styles.copyButton}
                      icon={<Icon className={styles.copyIcon} name="copy" />}
                    />
                  </span>
                }
              />
            </Form.Field>
          </Form.Group>
        </Form>
      </Formik>
    </>
  );
};

export default connect(state => {
  return {
    generalTaskList: state.newTasks.list.content
  };
})(NewIntervalForm);
